import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'iposcen-ipos-help-uninstalling-chromebook',
  templateUrl: './ipos-help-uninstalling-chromebook.component.html',
  styleUrls: ['./ipos-help-uninstalling-chromebook.component.scss']
})
export class IposHelpUninstallingChromebookComponent implements OnInit {
  @ViewChild('uninstallChrome') uninstallChrome: ElementRef;
  @ViewChild('method1') method1: ElementRef;
  @ViewChild('method2') method2: ElementRef;
  isMethod1 = true;
  isMethod2 = true;
  constructor() { }

  ngOnInit(): void {
  }

  change(data) {
    if (data === 'uninstallChrome'){
      setTimeout(() => {
        this.uninstallChrome.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'method1') {
      setTimeout(() => {
        this.method1.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'method2') {
      setTimeout(() => {
        this.method2.nativeElement.scrollIntoView();
      }, 0);
    }
  }

  showDescription(data) {
    if(data === 'method1'){
      this.isMethod1 = !this.isMethod1;
    }else if (data === 'method2'){
      this.isMethod2 = !this.isMethod2;
    } 
  }

}
